import { isEmptyValue } from './managerUtils';
import { FormItemSaved } from '../types/types';

// The item's `saved` rules: omitIfEmpty skips an empty value, onPOST/onPUT
// (default true) skip the field for that method. Without a method only
// omitIfEmpty applies.
export const shouldSendFormValue = (
  saved: FormItemSaved | undefined,
  value: unknown,
  method?: 'POST' | 'PUT'
): boolean => {
  if (!saved) {
    return true;
  }

  if (saved.omitIfEmpty && isEmptyValue(value)) {
    return false;
  }

  if (method === 'POST' && saved.onPOST === false) {
    return false;
  }

  if (method === 'PUT' && saved.onPUT === false) {
    return false;
  }

  return true;
};
